/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumChatMessageCreateCausedBy = {
  ChatMessage: 'chat_message',
  PublishToContact: 'publish_to_contact'
} as const
export type EnumChatMessageCreateCausedBy =
  typeof EnumChatMessageCreateCausedBy[keyof typeof EnumChatMessageCreateCausedBy]

export function EnumChatMessageCreateCausedByFromJSON(json: any): EnumChatMessageCreateCausedBy {
  return EnumChatMessageCreateCausedByFromJSONTyped(json, false)
}

export function EnumChatMessageCreateCausedByFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EnumChatMessageCreateCausedBy {
  return json as EnumChatMessageCreateCausedBy
}

export function EnumChatMessageCreateCausedByToJSON(value?: EnumChatMessageCreateCausedBy | null): any {
  return value as any
}
